import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import { useNavigate } from 'react-router-dom';
import WalletDetailsForm from './forms/WalletDetailsForm';
import CommonMyOrganizationContainer from '../common/components/CommonMyOrganizationContainer';
import RouterPaths from '../constants/RouterPaths';
import { clearStripeValidationMessage } from '../register/RegisterActions';
import { getPaymentMethod } from './MyWalletActions';

function MyWalletPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isOwner = useSelector((state) => state.auth.get('isOwner'));
  const last4 = useSelector((state) => state.myWallet.get('last4'));
  const [hasAccess, setHasAccess] = useState(false);

  const initialValues = {
    cardNumber: last4 ? `**** **** **** ${last4}` : '',
    cardholder: '',
  };

  useEffect(() => {
    if (!isOwner) {
      setHasAccess(false);
      return navigate(RouterPaths.DASHBOARD);
    }
    return setHasAccess(true);
  }, [isOwner, navigate]);

  useEffect(() => {
    dispatch(getPaymentMethod());
  }, [dispatch]);

  useEffect(() => () => dispatch(clearStripeValidationMessage()), [dispatch]);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {hasAccess && (
        <CommonMyOrganizationContainer>
          <Formik initialValues={initialValues} onSubmit={() => null} enableReinitialize>
            {({ values }) => <WalletDetailsForm values={values} />}
          </Formik>
        </CommonMyOrganizationContainer>
      )}
    </>
  );
}

export default MyWalletPage;
